<div class="inactive-container">
  <mat-icon>warning</mat-icon>
  <h1>This link is no longer active</h1>
  Please check with the person who shared the link with you.
</div>
